import { ErrorMessage, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import {
  AddAccomodationInitialValues,
  AccomodationValidationSchema,
} from "./AddAccomodationMethods/FormikValidation";
import {
  StaffSubmitHandler,
  addModalInitialValuesHandler,
} from "./AddAccomodationMethods/AddAccomodationModalMethods";
import { AddOfficeProps } from "../../../../../Type";
import TextError from "../../../../../Components/FormikError/TextError";
import CustomButton from "../../../../../Components/CustomElements/FormElements/CustomButton";
import Select from "react-select";

const AddAccomodation = ({ setIsOpen, modalEditData, refetch ,districtList  }: AddOfficeProps) => {
  const [addModalInitialValues, setAddModalInitialValues] = useState(
    AddAccomodationInitialValues
  );
  const [editMode, setEditMode] = useState<boolean>(false);

  useEffect(() => {
    addModalInitialValuesHandler(
      modalEditData,
      setAddModalInitialValues,
      setEditMode
    );
  }, [modalEditData]);

  return (
    <Formik
      validationSchema={AccomodationValidationSchema}
      initialValues={addModalInitialValues}
      enableReinitialize
      onSubmit={(values, actions) => {
        StaffSubmitHandler(
          values,
          actions,
          setIsOpen,
          refetch,
          editMode,
          modalEditData?.[0]?.id
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        isSubmitting,
        values,
        setFieldValue,
        setFieldError,
        errors,
      }) => {

        return (
          <div className="form-wrap">
            <Form onSubmit={handleSubmit}>
              <Row className="gy-4">
                <Col lg={12}>
                  <Label>Accomodation</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    value={values?.name}
                    name="name"
                    placeholder="Accomodation Name"
                  />
                  <ErrorMessage name="name" component={TextError} />
                </Col>
                <Col md={12}>
                  <Label>District</Label>
                  <Select
                    placeholder="Select District"
                    options={districtList}
                    value={
                      districtList?.filter(
                        (itm: any) => itm?.value === values?.district
                      ) || ""
                    }
                    onChange={(e: any) => {
                      setFieldValue("district", e?.value);
                    }}
                    name="district"
                    isLoading={false}
                    loadingMessage={() => "Fetching District"}
                    noOptionsMessage={() => "District appears here"}
                    isSearchable={true}
                    isClearable
                  />
                  <ErrorMessage name="district" component={TextError} />
                </Col>

                <Col lg={12}>
                  <CustomButton
                    isLoading={isSubmitting}
                    label="Submit"
                    color="primary"
                    className="sm submit-btn"
                  />
                </Col>
              </Row>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddAccomodation;
